/**
 * React context that exposes the typed `AdminClient` to the app tree.
 * Same pattern as the dashboard's `api-context.tsx` (the dashboard
 * exposes a multi-bag `SillApi`; the admin's surface is one bag,
 * the `AdminClient`).
 */

import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

import type { AdminClient } from './admin-client.js';

const AdminApiCtx = createContext<AdminClient | null>(null);

export interface AdminApiProviderProps {
  children: ReactNode;
  api: AdminClient;
}

export function AdminApiProvider({ children, api }: AdminApiProviderProps): JSX.Element {
  return <AdminApiCtx.Provider value={api}>{children}</AdminApiCtx.Provider>;
}

export function useAdminApi(): AdminClient {
  const ctx = useContext(AdminApiCtx);
  if (ctx === null) {
    throw new Error('useAdminApi() called outside <AdminApiProvider>');
  }
  return ctx;
}
